"use client"

import Link from "next/link"
import { IconQrcode, IconMail, type Icon } from "@tabler/icons-react"

import { Button } from "@/components/ui/button"
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

export function NavMain({
  items,
  pathname,
}: {
  items: {
    title: string
    url: string
    icon?: Icon
  }[]
  pathname?: string
}) {
  return (
    <SidebarGroup>
      <SidebarGroupContent className="flex flex-col gap-2">
        <SidebarMenu>
          <SidebarMenuItem className="flex items-center gap-2">
            <SidebarMenuButton
              tooltip="Create QR Code"
              asChild
              className="bg-black text-white hover:bg-black/80 dark:bg-white dark:text-black dark:hover:bg-white/90 min-w-8 duration-200 ease-linear shadow-md"
            >
              <Link href="/dashboard/qr-codes?create=true">
                <IconQrcode />
                <span>Quick Create</span>
              </Link>
            </SidebarMenuButton>
            <Button
              asChild
              size="icon"
              className="size-8 group-data-[collapsible=icon]:opacity-0 border-border text-muted-foreground hover:bg-accent hover:text-accent-foreground"
              variant="outline"
            >
              <a href="mailto:support@pcloud.com.my" target="_blank" rel="noopener noreferrer">
                <IconMail />
                <span className="sr-only">Contact Support</span>
              </a>
            </Button>
          </SidebarMenuItem>
        </SidebarMenu>
        <SidebarMenu>
          {items.map((item) => (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton
                tooltip={item.title}
                asChild
                className={pathname === item.url
                  ? "bg-violet-500/10 text-violet-700 dark:text-violet-300 hover:bg-violet-500/15"
                  : ""}
              >
                <Link href={item.url}>
                  {item.icon && <item.icon />}
                  <span>{item.title}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  )
}
